import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private appService: AppService,
    private navController: NavController,
  ) {}

  private setAuthorizationHeader(req: HttpRequest<any>): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set(
        'Authorization',
        `Bearer ${this.appService.accessToken}`,
      ),
    });
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.appService.accessToken) {
      req = this.setAuthorizationHeader(req);
    }

    return next.handle(req).pipe(
      switchMap((event) => {
        if (event instanceof HttpResponse) {
          if (
            event.body instanceof Blob &&
            event.body.type === 'application/json'
          ) {
            return this.appService.refreshTokens().pipe(
              switchMap(() => next.handle(this.setAuthorizationHeader(req))),
              tap(async (newEvent) => {
                if (
                  newEvent instanceof HttpResponse &&
                  !newEvent.body.success &&
                  newEvent.body.success &&
                  newEvent.body.extras?.kick
                ) {
                  await this.appService.logout();
                  await this.navController.navigateBack(['/login'], {
                    replaceUrl: true,
                  });
                }
              }),
            );
          }
          if (
            !event.body.success &&
            event.body.extras?.jwt &&
            event.body.errors?.some((e: any) => e.code === 'EX-0006')
          ) {
            return this.appService.refreshTokens().pipe(
              switchMap(() => next.handle(this.setAuthorizationHeader(req))),
              tap(async (newEvent) => {
                // console.error('NEW EVENT:', newEvent);
                if (
                  newEvent instanceof HttpResponse &&
                  !newEvent.body.success &&
                  newEvent.body.extras?.jwt
                ) {
                  await this.appService.logout();
                  await this.navController.navigateBack(['/login'], {
                    replaceUrl: true,
                  });
                }
              }),
            );
          }
        }

        return of(event);
      }),
      // 👇 Catch and handle HTTP errors, especially 401
      tap({
        error: async (error) => {
          if (
            error.status === 401 ||
            error.status === 403 ||
            error.error?.errors?.some((e: any) => e.code === 'EX-0006')
          ) {
            await this.appService.logout();
            await this.navController.navigateBack(['/login'], {
              replaceUrl: true,
            });
          }
        },
      }),
    );
  }
}
